import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import AdminSettings from './components/AdminSettings';
import Sidebar from './components/SideBar';
import NotificationAdmin from './components/NotificationAdmin';


const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<AdminLogin />} />
        <Route path="/dashboard" element={<AdminDashboard />} />
        <Route path="/settings" element={<AdminSettings />} />
        <Route path="/notifications" element={<NotificationAdmin />} />
        <Route path="/sidebar" element={<Sidebar />} />
        

      </Routes>
    </Router>
  );
};

export default App;
